import React from 'react';
import MainLayout from '../Layouts/Mainlayout';
import DashboardContent from './DashboardContent';



const Dashboard: React.FC = () => {
  return (
    <div className="flex flex-row justify-start">
      <MainLayout>
        <DashboardContent />
      </MainLayout>
    </div>
  );
};

export default Dashboard;